<div class="spinner-container">
  <img class="spinner" src="./assets/svgs/loading.svg">
</div>
